var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(21,27,38,.75)",
    viewBox: "0 0 24 24",
    title: "graph",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--fadedBlack",
    d: "M23.0002 0V5C23.0002 5.6 22.6002 6 22.0002 6C21.4002 6 21.0002 5.6 21.0002 5V3.4L12.3002 12.1C12.1002 12.3 11.8002 12.3 11.7002 12.1L9.0002 9.4L3.4002 15C3.0002 15.4 2.4002 15.4 2.0002 15C1.6002 14.6 1.6002 14 2.0002 13.6L8.6002 7C8.8002 6.8 9.2002 6.8 9.4002 7L12.0002 9.6L19.6002 2H18.0002C17.4002 2 17.0002 1.6 17.0002 1C17.0002 0.4 17.4002 0 18.0002 0H23.0002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 24C1.9 24 1 23.1 1 22V18C1 16.9 1.9 16 3 16C4.1 16 5 16.9 5 18V22C5 23.1 4.1 24 3 24ZM14 22V15C14 13.9 13.1 13 12 13C10.9 13 10 13.9 10 15V22C10 23.1 10.9 24 12 24C13.1 24 14 23.1 14 22ZM23 22V12C23 10.9 22.1 10 21 10C19.9 10 19 10.9 19 12V22C19 23.1 19.9 24 21 24C22.1 24 23 23.1 23 22Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.bbd62025.svg";
export { ForwardRef as ReactComponent };